import { GetterTree } from 'vuex';
import { ClaimState, Claim, ClaimCommentPaginator, ClaimComment } from './types';
import { RootState, Attachment } from '@/types';

export const getters: GetterTree<ClaimState, RootState> = {
    claim(state): Claim | undefined {
        const claim  = state.data.claim || undefined;
        return claim;
    },
    comments(state): ClaimCommentPaginator | undefined {
        const comments = state.data.comments || undefined;
        return comments;
    },
    attachments(state): Attachment[] | undefined {
        const attachments = state.data.attachments || undefined;
        return attachments;
    },
    reminders(state): ClaimComment[] | undefined {
        const reminders = state.data.reminders || undefined;
        return reminders;
    },
    payments(state): ClaimComment[] | undefined {
        const payments = state.data.payments || undefined;
        return payments;
    },
    interests(state): string | undefined {
        const payments = state.data.interests || undefined;
        return payments;
    },
};
